<template>
  <div class="invoice-create-page">
    <!--  credit form component -->
    <UserRoleForm
      page="create"
      v-on:FormUpdate="FormUpdate = 1"
      :submitted="submitted"
      v-on:onSubmit="onSubmit($event)"
    ></UserRoleForm>
  </div>
</template>

<script>
import UserRoleForm from "@/components/Form/Settings/Users/UserRole/UserRoleForm"; // credit form for create and update
import { notificationMixin } from "@/mixins/notification"; // global fucntion for calling notification
import { mapState } from "vuex"; // get data set in the state in vuex

export default {
  name: "InvoiceCreate",
  mixins: [notificationMixin], // call the glbal mixin fucntion
  components: {
    UserRoleForm
  },
  data() {
    return {
      FormUpdate: 0,
      submitted: false,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center" // notification design class
    };
  },
  methods: {
    onSubmit(data) {
      this.submitted = true;
      this.$store
        .dispatch("userrole/createList", data)
        .then(() => {
          this.FormUpdate = 0; // to hide before route leave confirmation message
          var message, type;
          if (this.code == 200) {
            //  show if invoice successfully created
            message = "New Role has been created successfully!";
            type = "success";
            this.$router.push({
              name: "UserRole"
            });
          } else {
            this.submitted = "false";
            //  showing eror message
            message = "Role with this name is already present !";
            type = "danger";
          }
          //  code for notificatin display
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: message,
            type: type,
            showCloseButton: true
          });
        })
        .catch(() => {});
    }
  },
  created() {
    this.initializationMessengerCode();
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air"
    };
  },
  beforeRouteLeave(routeTo, routeFrom, next) {
    //  alert message before leaving route to confirm unsave the changes
    if (this.FormUpdate == 1) {
      //  alert message to confirm
      const answer = window.confirm(
        "Do you really want to leave? you have unsaved changes!"
      );
      //  if okay move to next route
      if (answer) {
        next();
      } else {
        //  stay on the page
        next(false);
      }
    } else {
      //  move to the route if they had not done any changes
      next();
    }
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapState({
      code: state => state.userrole.code,
      updated_id: state => state.userrole.updated_id
    })
  }
};
</script> 

<style>
</style>
